import clsx from 'clsx';
import { HTMLMotionProps, motion } from 'framer-motion';
import React, { FC, ReactNode } from 'react';

import { EXIT_DURATIONS } from '1_components/Transitition/settings';

import S from './RevealAnimation.module.scss';

export interface RevealAnimationProps extends HTMLMotionProps<'div'> {
  className?: string;
  children: ReactNode;
  subtle?: boolean;
  delay?: number;
}

const RevealAnimation: FC<RevealAnimationProps> = ({
  className,
  children,
  subtle,
  delay = 0,
  ...rest
}) => {
  const REVEAL_ANIMATION_FULL = {
    initial: { opacity: 0, y: '100%' },
    animate: { opacity: 1, y: 0 },
    exit: {
      opacity: 1,
      y: '-100%',
      transition: {
        duration: EXIT_DURATIONS.max * 1.25,
        ease: 'easeInOut',
        delay: 0,
      },
    },
    transition: {
      duration: EXIT_DURATIONS.max * 1.25,
      ease: 'easeInOut',
      delay,
    },
  };

  const REVEAL_ANIMATION = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: EXIT_DURATIONS.max, ease: 'easeInOut', delay }, // Added delay here
  };

  return (
    <span className={clsx(S.RevealAnimation, className)}>
      <motion.span
        style={{ display: 'block' }}
        {...(subtle ? REVEAL_ANIMATION : REVEAL_ANIMATION_FULL)}
        {...rest}
      >
        {children}
      </motion.span>
    </span>
  );
};
export default RevealAnimation;
